import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-zinc-400 py-12 px-4 sm:px-6 lg:px-8 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-sm">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/b0fdc4e391d0a3ab43ffd053ddd167ff.jpg" 
              alt="AlienProduction Logo" 
              className="w-6 h-6 rounded-full object-cover bg-white" 
            />
            <span className="font-semibold text-zinc-300">AlienProduction</span>
          </Link>
        </div>

        <p className="order-3 md:order-2">
          &copy; {new Date().getFullYear()} AlienProduction. All rights reserved.
        </p>

        <div className="flex gap-6 order-2 md:order-3">
          <Link to="/imprint" className="hover:text-white transition-colors">
            Imprint
          </Link>
          <Link to="/privacy" className="hover:text-white transition-colors">
            Privacy
          </Link>
          <a href="mailto:hello@alienproduction.com" className="hover:text-white transition-colors">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;